var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPercent = function SvgPercent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.795 10.8q-1.245 0-2.12-.88A2.9 2.9 0 0 1 4.8 7.795q0-1.245.88-2.12A2.9 2.9 0 0 1 7.805 4.8q1.245 0 2.12.88t.875 2.125-.88 2.12a2.9 2.9 0 0 1-2.125.875M7.8 9q.5 0 .85-.35T9 7.8t-.35-.85a1.16 1.16 0 0 0-.85-.35q-.5 0-.85.35t-.35.85.35.85.85.35m8.395 10.2q-1.245 0-2.12-.88a2.9 2.9 0 0 1-.875-2.125q0-1.245.88-2.12a2.9 2.9 0 0 1 2.125-.875q1.245 0 2.12.88t.875 2.125-.88 2.12a2.9 2.9 0 0 1-2.125.875m.005-1.8q.5 0 .85-.35t.35-.85-.35-.85a1.16 1.16 0 0 0-.85-.35q-.5 0-.85.35t-.35.85.35.85.85.35M6.075 19.2 4.8 17.925 17.925 4.8 19.2 6.075z"
  })));
};
export default SvgPercent;